import { render, staticRenderFns } from "./MonitoringReportItem.vue?vue&type=template&id=52a8990f&scoped=true"
import script from "./MonitoringReportItem.vue?vue&type=script&lang=js"
export * from "./MonitoringReportItem.vue?vue&type=script&lang=js"
import style0 from "./MonitoringReportItem.vue?vue&type=style&index=0&id=52a8990f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8990f",
  null
  
)

export default component.exports